import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const formatPLN = (n) =>
  new Intl.NumberFormat("pl-PL", { style: "currency", currency: "PLN", maximumFractionDigits: 0 }).format(n);





const PricingPlans = () => {
  const handleRedirect = (plan) => {
    window.location.href = `/select-license?plan=${plan}`;
  };

  // Base monthly prices
  const PRICES = {
    BASIC: 199,
    PRO: 299,
    ENTERPRISE: 499,
  };

 const navigate = useNavigate();

  return (
    <PlansContainer>
      <DiscountBanner>
        Uzyskaj dodatkowy rabat do <strong>20%</strong> dla zakupu na <strong>12</strong> miesięcy!
      </DiscountBanner>

      <Header>Najpopularniejsze Plany</Header>

      <PlansWrapper>
        {/* BASIC */}
        <PlanCard>
          <PlanHeader>Basic</PlanHeader>
          <PlanPrice>{formatPLN(PRICES.BASIC)} / miesiąc</PlanPrice>
          
          <PlanDetails>
             <Detail>Generowanie aktualnego i pełnego odpisu KRS kontrahenta</Detail>
             <Detail><strong>3</strong> raporty weryfikacji wiarygodności kontrahenta miesięcznie</Detail>
             <Detail><strong>Darmowy raport</strong> weryfikacji firmy klienta</Detail>
          </PlanDetails>
          <PlanButton onClick={() => handleRedirect("BASIC")}>Rozpocznij</PlanButton>
        </PlanCard>

        {/* PRO */}
        <PlanCard $highlighted>
          <PlanHeader>Pro</PlanHeader>
          <PlanPrice>{formatPLN(PRICES.PRO)} / miesiąc</PlanPrice>

          
          <PlanDetails>
            <Detail><strong>10</strong> raporty weryfikacji wiarygodności kontrahenta miesięcznie</Detail>
            <Detail>Generowanie aktualnego i pełnego odpisu KRS kontrahenta</Detail>
            <Detail>Eksport raportów do <strong>PDF</strong> i <strong>Excela</strong></Detail>
            <Detail><strong>Darmowy raport</strong> weryfikacji firmy klienta</Detail>
          </PlanDetails>
          <PlanButton $highlighted onClick={() => handleRedirect("PRO")}>Rozpocznij</PlanButton>
        </PlanCard>

        {/* ENTERPRISE */}
        <PlanCard>
          <PlanHeader>ENTERPRISE</PlanHeader>
          <PlanPrice>{formatPLN(PRICES.ENTERPRISE)} / miesiąc</PlanPrice>
          
          <PlanDetails>
            
            <Detail><strong>20</strong> raporty weryfikacji wiarygodności kontrahenta miesięcznie</Detail>
            <Detail>Eksport raportów do <strong>PDF</strong> i <strong>Excela</strong></Detail>
            <Detail><strong>Darmowy raport</strong> weryfikacji firmy klienta</Detail>
          </PlanDetails>
          <PlanButton onClick={() => handleRedirect("ENTERPRISE")}>Rozpocznij</PlanButton>
        </PlanCard>
      </PlansWrapper>

      <AdditionalHeader>Dodatkowe opcje</AdditionalHeader>
      <AdditionalWrapper>
        {/* Pakiet Kontrahent (jednorazowy) */}
{/*         <AdditionalCard>
          <PlanHeader>Pakiet Kontrahent</PlanHeader>
          <PlanPrice>149 PLN <SmallNote>jednorazowo</SmallNote></PlanPrice>
          <PlanDescription>Dostęp tylko do raportów kontrahentów.</PlanDescription>
          <PlanDetails>
            <Detail><strong>5</strong> raportów weryfikacji wiarygodności kontrahenta</Detail>
            <Detail><strong>5</strong> raportów powiązań</Detail>
            <Detail><strong>Darmowy raport</strong> weryfikacji firmy klienta</Detail>
          </PlanDetails>
          <AdditionalButton onClick={() => handleRedirect("PAKIET-KONTRAHENT")}>
            Zamów pakiet
          </AdditionalButton>
        </AdditionalCard>
 */}
        {/* Indywidualne raporty */}
        <AdditionalCard>
          <PlanHeader>Indywidualne raporty</PlanHeader>
          <PlanPrice>Wycena indywidualna</PlanPrice>
          <PlanDescription>Raporty i zmiany dopasowane do Twoich potrzeb.</PlanDescription>
          <PlanDetails>
            <Detail>Raporty dopasowane do wymagań</Detail>
            <Detail>Indywidualne konsultacje</Detail>
          </PlanDetails>
    <AdditionalButton onClick={() => navigate("/contact")}>
      Skontaktuj się
    </AdditionalButton>
        </AdditionalCard>
      </AdditionalWrapper>
    </PlansContainer>
  );
};

export default PricingPlans;

/* ===== styles (kept your look & feel) ===== */

export const PlansContainer = styled.div`
  text-align: center;
  padding: 2rem 1rem;
  background: url("/back.jpg") no-repeat center center fixed;
  background-size: cover;
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.8);
`;

export const DiscountBanner = styled.div`
  display: inline-block;
  margin: 0 auto 1rem;
  background: rgba(59, 195, 204, 0.12);
  border: 1px solid rgba(59, 195, 204, 0.35);
  color: #0f172a;
  padding: 0.5rem 0.9rem;
  border-radius: 999px;
  font-weight: 600;
`;

export const Header = styled.h2`
  font-size: 2.5rem;
  font-weight: bold;
  color: #1f2937;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

export const PlansWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
align-items: stretch;  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 2rem;
  }
`;

export const PlanCard = styled.div`
  flex: 1;
  max-width: 350px;
  width: 100%;
  display: flex;      
  gap: 1rem;     /* stack content vertically */
  flex-direction: column; /* ...so the button can sit at the bottom */
  background: ${({ $highlighted }) =>
    $highlighted ? "linear-gradient(to bottom, #fbbf24, #fde68a)" : "white"};
  border: 2px solid ${({ $highlighted }) => ($highlighted ? "#f59e0b" : "#d1d5db")};
  border-radius: 12px;
  padding: 2rem;
  transition: all 0.3s ease;

  &:hover {
    border-color: ${({ $highlighted }) => ($highlighted ? "#f59e0b" : "#3bc3cc")};
    transform: scale(1.05);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 1024px) {
    max-width: 90%;
  }

  @media (max-width: 768px) {
    max-width: 80%;
    padding: 1rem;
  }
`;

export const PlanHeader = styled.div`
  font-size: 1rem;
  font-weight: bold;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 0.6rem;
`;

export const PlanPrice = styled.div`
  font-size: 2rem;
  font-weight: bold;
  color: #1f2937;
  margin-bottom: 0.25rem;

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`;

export const SmallNote = styled.span`
  font-size: 0.9rem;
  font-weight: 600;
  color: #6b7280;
  margin-left: 0.25rem;
`;

export const BadgesRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.35rem;
  margin: 0.35rem 0 0.6rem;
`;

export const Badge = styled.span`
  display: inline-block;
  font-size: 0.85rem;
  color: ${({ $accent }) => ($accent ? "#0f172a" : "#0f172a")};
  background: ${({ $accent }) =>
    $accent ? "rgba(59, 195, 204, 0.18)" : "rgba(2, 6, 23, 0.06)"};
  border: 1px solid ${({ $accent }) => ($accent ? "rgba(59,195,204,0.35)" : "#e5e7eb")};
  padding: 0.28rem 0.6rem;
  border-radius: 999px;
  font-weight: 600;
`;

export const PlanDescription = styled.div`
  font-size: 0.95rem;
  color: #6b7280;
  margin: 0.6rem 0 1rem;
`;

export const PlanDetails = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem;
  margin-top: 0.5rem;
  text-align: left;

 & > div:last-child {
  border-bottom: none;
  padding-bottom: 0;
+ }
`;

export const Detail = styled.div`
  font-size: 1rem;
  color: #1f2937;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 0.5rem;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

export const PlanButton = styled.button`
  background: ${({ $highlighted }) => ($highlighted ? "#f59e0b" : "#3bc3cc")};
  color: white;
  padding: 0.75rem 2rem;
  border: none;
  border-radius: 30px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  margin-top: auto; 
  transition: all 0.3s ease;

  &:hover {
    background: ${({ $highlighted }) => ($highlighted ? "#d97706" : "black")};
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    padding: 0.6rem 1.1rem;
    font-size: 0.9rem;
  }
`;

export const AdditionalWrapper = styled(PlansWrapper)`
  margin-top: 2.5rem;
`;

export const AdditionalCard = styled(PlanCard)`
  background: #f3f4f6;
  border: 1px dashed #9ca3af;
  box-shadow: none;
  transition: none;

  &:hover {
    transform: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }
`;

export const AdditionalHeader = styled.h3`
  font-size: 1.8rem;
  color: #374151;
  margin: 3rem 0 1.2rem;

  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`;

export const AdditionalButton = styled(PlanButton)`
  background: transparent;
  color: #2563eb;
  border: 2px solid #2563eb;

  &:hover {
    background: #2563eb;
    color: white;
    transform: scale(1.05);
  }
`;
